import fetch from '@/utils/fetch'

/**
 * 直播
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getLive(data = {}) {
  return fetch({
    url: '/api_zaiart/service/zaiart/w/webapp/live/detail',
    method: 'post',
    data
  })
}

/**
 * 直播间
 *
 * @export
 * @param {any} data
 * @returns
 */
export function liveInterface(data = {}) {
  return fetch({
    url: '/api_zaiart/service/zaiart/aw/mul/ow/live/interface',
    method: 'post',
    data
  })
}

/**
 * 直播间sig
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getLiveSig(data = {}) {
  return fetch({
    url: '/api_zaiart/service/zaiart/aw/mul/ow/live/sig/get',
    method: 'post',
    data
  })
}
